import { render, staticRenderFns } from "./GoodsImageInfo.vue?vue&type=template&id=c22956ce&scoped=true"
import script from "./GoodsImageInfo.vue?vue&type=script&lang=ts"
export * from "./GoodsImageInfo.vue?vue&type=script&lang=ts"
import style0 from "./GoodsImageInfo.vue?vue&type=style&index=0&id=c22956ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22956ce",
  null
  
)

export default component.exports